import React, { Component, useEffect } from 'react';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from './services/AuthService';
import AdminFunctions from './admin/AdminFunctions';
import Session from './auth/Session';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        
        if (!isAuthenticated) {
            this.props.history.push('/login');
        } else {
            //var isAdmin = await AdminFunctions.isAdminAsync();
            //if (isAdmin) {
            //    window.location.href = '/admin/clients'
            //}
            //else {
            //    window.location.href = '/Lease/LeaseSearch';
            //    //this.props.history.push('/');
            //}
        }
    }

    async componentWillMount() {
        this.checkAuthenticated();
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    render() {
        return (
            <></>
        );
    }
}
